import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ForminputEmail from '../forminput/forminput_email.js';
import ForminputPassword from '../forminput/forminput_password.js';
import GoogleAuthButton from "./google_auth_button.js";


export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            loginError: "",
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp"
        };
        this.setFormValue = this.setFormValue.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
    }


    setFormValue(label, value) {
        // Update state
        this.setState({
            [label]: value
        });
    }


    async submitRequest() {
        const componentInstance = this;
        componentInstance.props.setLoading();
        const params = new URLSearchParams(this.props.location.search);
        const redirect = params.get("redirect") || "/"; // Default to home if no redirect

        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${this.props.token}`
                },
                body: JSON.stringify({
                    email: this.state.email,
                    password: this.state.password
                }),
            });
            // Handle response
            response = await response.json();
            const data = response.value;
            //Proceed based on status
            if (response.status == 200) {
                componentInstance.props.setLogin(true, data.id, data.email, data.token, redirect, data.admin_role);
                componentInstance.props.unsetLoading();
            } else {
                componentInstance.setState({
                    loginError: "Wrong email or password"
                });
                componentInstance.props.unsetLoading();
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Login_submitRequest");
            componentInstance.props.unsetLoading();
        }
    }


    render() {

        return (
            <div className="content-container login-container">
                <img src={this.state.background_url} alt={""} className={"login__background"} />
                <div className="login__background login__background--overlay"></div>
                <form
                    className="login-wrapper"
                    onSubmit={e => {
                        e.preventDefault();
                        this.submitRequest();
                    }}
                >

                    <div className="login">
                        <div className="login__element login__title text-subtitle">
                            Log in
                        </div>

                        <div className="login__element form__content__element form__content__input">
                            <ForminputEmail
                                name={"email"}
                                label={"Email"}
                                default_value={""}
                                setFormValue={this.setFormValue.bind(this)}
                                required={true}
                                note={"Your email address"}
                            />
                        </div>

                        <div className="login__element form__content__element form__content__input">
                            <ForminputPassword
                                name={"password"}
                                label={"Password"}
                                default_value={""}
                                setFormValue={this.setFormValue.bind(this)}
                                required={true}
                                note={"Your password"}
                            />
                        </div>

                        {this.state.loginError && this.state.loginError != "" &&
                            <div className="login__element form__content__element text-color-primary">
                                {this.state.loginError}
                            </div>
                        }

                        <div className="login__element form__content__element form__content__buttonbox">
                            <button
                                type="submit"
                                className="form__content__buttonbox__button button button-primary"
                            >
                                Log In
                            </button>
                            <GoogleAuthButton
                                label={"Sign in with Google"}
                            />
                        </div>

                        <div className="login__element form__content__element">
                            <Link to={"/resetpassword"} className="">
                                Reset password
                            </Link>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
